import { PRIVACY_URL, TERMS_URL } from '../constants/AppConstants';


const viewTermsAndCondition = () => {
    window.open(TERMS_URL, '_blank');
}

const viewPrivacyPolicy = () => {
    window.open(PRIVACY_URL, '_blank')
}

export {viewPrivacyPolicy, viewTermsAndCondition};